import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import { Circle, Text, Group, Image as KonvaImage } from 'react-konva';
import { useTranslation } from 'react-i18next';

const FloorplanAnimatedTable = ({ x, y, status, radius, checkImg, busyImg, registerAnimation, onClick }) => {
  const groupRef = useRef();
  const innerRef = useRef();
  const outerRef = useRef();

  const isAvailable = status === 'available';
  const isSelected = status === 'selected';
  const isBusy = status === 'busy';
  const perfectDrawEnabled = /iPad|iPhone|iPod/.test(navigator.userAgent) ? false : true;

  const { t } = useTranslation();

  useEffect(() => {
    if (!isAvailable || !registerAnimation) return;

    let startTime = null;
    const duration = 2700;

    registerAnimation((frame) => {
      if (!frame?.time) return;
      if (!startTime) startTime = frame.time;

      const t = ((frame.time - startTime) % duration) / duration;

      if (innerRef.current) {
        if (t <= 0.15) {
          innerRef.current.scale({
            x: 1 - 0.34 * (t / 0.15),
            y: 1 - 0.34 * (t / 0.15),
          });
        } else if (t <= 0.3) {
          innerRef.current.scale({
            x: 0.66 + 0.34 * ((t - 0.15) / 0.15),
            y: 0.66 + 0.34 * ((t - 0.15) / 0.15),
          });
        } else {
          innerRef.current.scale({ x: 1, y: 1 });
        }
      }

      if (outerRef.current) {
        if (t < 0.27) {
          outerRef.current.scale({ x: 1, y: 1 });
          outerRef.current.opacity(0);
        } else if (t < 0.666) {
          const scale =
            1 + (4 - 1) * ((t - 0.27) / (0.666 - 0.27));
          const opacity =
            0.6 * (1 - (t - 0.27) / (0.666 - 0.27));
          outerRef.current.scale({ x: scale, y: scale });
          outerRef.current.opacity(opacity);
        } else {
          outerRef.current.scale({ x: 4, y: 4 });
          outerRef.current.opacity(0);
        }
      }
    });
  }, [isAvailable, registerAnimation]);

  return (
    <Group
      x={x}
      y={y}
      ref={groupRef}
      onClick={onClick}
      onTap={onClick}
      offsetX={radius}
      offsetY={radius}
      listening
      onMouseEnter={() => {
        document.body.style.cursor = 'pointer';
      }}
      onMouseLeave={() => {
        document.body.style.cursor = 'default';
      }}
    >
      {isAvailable && (
        <Circle ref={outerRef} radius={radius} fill="rgba(255,255,255,0.3)" stroke="white" strokeWidth={1} opacity={0} perfectDrawEnabled={perfectDrawEnabled} />
      )}
      {isAvailable && <Circle ref={innerRef} radius={radius} fill="white" perfectDrawEnabled={perfectDrawEnabled} />}
      {!isAvailable && (
        <Circle radius={radius * 2} fill="rgba(102,102,102,0.2)" stroke="white" strokeWidth={3} perfectDrawEnabled={perfectDrawEnabled} />
      )}

      {isSelected && checkImg && (
        <KonvaImage
          image={checkImg}
          width={radius * 3}
          height={radius * 3}
          offsetX={radius * 1.5}
          offsetY={radius * 1.5}
        />
      )}

      {isBusy && busyImg && (
        <>
          <KonvaImage
            image={busyImg}
            width={radius * 3}
            height={radius * 3}
            offsetX={radius * 1.5}
            offsetY={radius * 1.5}
          />
          <Text
            text={t('bookings.busy')}
            fontSize={24}
            fontStyle="bold"
            fill="white"
            align="center"
            verticalAlign="middle"
            y={radius * 2 + 10}
            width={radius * 6}
            offsetX={radius * 3}
          />
        </>
      )}
    </Group>
  );
};

export default FloorplanAnimatedTable;
